import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// Don't install timezone with advanced format plugins as it breaks DATE_API_UTC_FORMAT const format

dayjs.extend(utc)
dayjs.extend(customParseFormat)
